import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'participations'
})


export class Participations implements PipeTransform {

  filtrer(tickets) {
    let tmp = [];
    for( let i = 0 ; i < tickets.length; i++) {
      if(tickets[i].order_id && tickets[i].order && tickets[i].order.state ) {
        tmp.push(tickets[i]);
      }
    }
    return tmp.length;
  }
  transform(tickets:any): any {
    return this.filtrer(tickets) ;
  }
}
